<template>
    <div>
        <user-avatar class="is-pulled-right avatar"/>

        <div class="select-note editor-container has-text-centered">
            <div class="is-clearfix"></div> <br/><br/><br/>
            <img src="../../assets/img/note.png" width="250rem" alt=""/><br/><br/><br/>
            <b class="title is-4">Please select note</b><br/><br/><br/>
        </div>
    </div>
</template>

<script>
import UserAvatar from '../user/UserAvatar.vue';

export default {
    name: 'NoteNotSelected',
    components: { UserAvatar },
};
</script>

<style scoped>
    .select-note {
        margin-top: 1.5rem;
    }

    .avatar {
        margin-top: 1.75rem;
        margin-right: 1rem;
    }
</style>
